if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /* TPL patch 2026-04-17 (grill v2 #13): strip <script> tags from fetched HTML
         before innerHTML insertion to prevent script re-execution / XSS. The
         prior Dawn implementation re-injected every script tag so it would
         execute — dangerous if the fetched HTML is ever tampered with (XSS
         reflected through product pages) and a known anti-pattern. Preserve
         only scripts whose src is on a trusted allowlist (Shopify CDN /
         theprintloft.art). Inline scripts are always dropped. */
      setInnerHTML(element, html) {
        const ALLOWED_SCRIPT_HOSTS = /(^|\.)(shopify\.com|shopifycdn\.com|theprintloft\.art)$/i;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const scripts = Array.from(parsed.querySelectorAll('script'));
        const safeSrcScripts = [];

        scripts.forEach((s) => {
          const src = s.getAttribute('src');
          const type = (s.getAttribute('type') || '').toLowerCase();

          // Preserve non-executable data blocks (variant JSON, schema, etc.)
          // These never execute JS — they're read as text by other code.
          if (type === 'application/json' || type === 'application/ld+json') {
            return;
          }

          if (src) {
            try {
              const url = new URL(src, window.location.origin);
              if (ALLOWED_SCRIPT_HOSTS.test(url.hostname)) {
                safeSrcScripts.push({ src: url.href, attrs: Array.from(s.attributes) });
              }
            } catch (_) {
              /* malformed src — drop */
            }
          }
          s.remove();
        });

        element.innerHTML = parsed.body.innerHTML;

        /* Re-append only allowlisted external scripts so Dawn variant JS that
           loads from Shopify CDN continues to work. Inline scripts are never
           re-executed from fetched HTML. */
        safeSrcScripts.forEach((entry) => {
          const newScriptTag = document.createElement('script');
          entry.attrs.forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          element.appendChild(newScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
